// extracted by mini-css-extract-plugin
export default {"staff":"StaffInfoBanner__staff--pLULb","relative-position":"StaffInfoBanner__relative-position--tk3Ij","relativePosition":"StaffInfoBanner__relative-position--tk3Ij"};